//@flow

import * as request from '../utils/request';
import {SEARCH_API_URL} from '../urls';
import type {SearchFetchParamsType} from './types';

export const requestSearch = (fetchParams: SearchFetchParamsType) =>
  request.get(SEARCH_API_URL, fetchParams);
